module.exports = __webpack_public_path__ + "static/media/top.69294f76.svg";